<ng-container *ngIf="country">
  <div class="fi fi-{{ countryCode }}"></div>
</ng-container>
